import { AutogenLayoutCycleCodeList } from "./autogen/AutogenLayoutCycleCodeList";

export class CycleCodeList extends AutogenLayoutCycleCodeList {

}
